import { create } from 'zustand';
import { getUserEventsApi } from '../../../api/api';

export const useEventsStore = create((set) => ({
  data: [],
  isLoading: false,
  error: null,
  total: 0,

  fetchUserEvents: async (page, limit, searchValue) => {
    set({ isLoading: true, error: null });

    await getUserEventsApi(
      page,
      limit,
      searchValue,
      (data) => {
        set({ data: data?.events || [], total: data.total, isLoading: false });
      },
      (err) => {
        set({ error: err.error || 'Ошибка при загрузке данных', isLoading: false });
      }
    );
  },
}));
